import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { trustHTML } from "@ember/template";
import { modifier } from "ember-modifier";
import { prioritizeNameInUx } from "discourse/lib/settings";
import DConditionalInElement from "discourse/ui-kit/d-conditional-in-element";
import DUserLink from "discourse/ui-kit/d-user-link";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import { i18n } from "discourse-i18n";

export default class PostNoticeCustom extends Component {
  @tracked createdByAnchorElement;

  registerCreatedByLink = modifier((element) => {
    this.createdByAnchorElement = element?.querySelector(".custom_created_by");
  });

  get createdByName() {
    if (!this.args.post.notice_created_by_user) {
      return;
    }

    return prioritizeNameInUx(this.args.post.notice_created_by_user.name)
      ? this.args.post.notice_created_by_user.name
      : this.args.post.notice_created_by_user.username;
  }

  <template>
    {{dIcon "user-shield"}}
    <div class="post-notice-message" {{this.registerCreatedByLink}}>
      {{trustHTML @notice.cooked}}
      {{#if this.createdByName}}
        {{trustHTML
          (i18n
            "post.notice.custom_created_by"
            userLinkHTML="<span class='custom_created_by'></span>"
          )
        }}
      {{/if}}
      {{! #in-element is used as an strategy to render the HTML content in the string from a real component
          instead defining it from a string }}
      <DConditionalInElement @element={{this.createdByAnchorElement}}>
        <DUserLink
          title={{this.createdByName}}
          @username={{@post.notice_created_by_user.username}}
          @ariaHidden={{false}}
        >
          {{this.createdByName}}
        </DUserLink>
      </DConditionalInElement>
    </div>
  </template>
}
